module.exports = __webpack_public_path__ + "static/img/2-13-普通维修建单.b0312cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/ppt/2-13-普通维修建单.png
// module id = 1348
// module chunks = 0